import { Navigate, createFileRoute, useParams, useRouterState } from '@tanstack/react-router';
import { legacyFeedTarget } from '../lib/feed-search.js';

/** The workspace-scoped half of the legacy /home redirect; see `./home.tsx`. */
export const Route = createFileRoute('/$workspaceSlug/home')({
  component: LegacyWorkspaceHomeRedirect,
});

export function LegacyWorkspaceHomeRedirect() {
  const { workspaceSlug } = useParams({ from: '/$workspaceSlug/home' });
  const search = useRouterState({ select: (state) => state.location.searchStr });
  const target: string = legacyFeedTarget(search, workspaceSlug);
  return <Navigate to={target} replace />;
}
